module.exports = __webpack_public_path__ + "img/hyundai-logo.b36791bc.webp";